<template>
    <div class="size-1-3 inline-card-cont">
        <div class='tep-tmp-open-btn'>
            <dx-button hint="Выбрать график" width='32px' height='32px' @click="openNsi">
                <img :src="'/infoenergo/assets/tep/tep-cards/arrow-right.svg'" alt='' class='w-full h-full'>
            </dx-button>
            <dx-popup
                ref="popupRef"
                height="95%"
                title='Справочник "Температуры СНИП и температурные графики источников"'
                :drag-enabled="true"
                :hide-on-outside-click="false"
                :show-close-button="true"
                :show-title="true"
                :visible="popupVisible"
                @hiding='onNsiClose'
            >
                <qs-temp-gr-view ref='tgrNsiRef' :from-card='true' @choose-tgr='onChooseTgr' />
            </dx-popup>
        </div>
        <div style='flex: 1'>
            <ai-form-text-box-readonly :meta='props.meta.metaName' :server-data='userData' :is-modified="isModified" />
        </div>
    </div>
    <div class="size-1-3 inline-card-cont">
        <ai-form-number-box-readonly :meta='meta.metaT1' :server-data='userData' :is-modified="isModified" />
        <ai-form-number-box-readonly :meta='meta.metaT2' :server-data='userData' :is-modified="isModified" />
        <ai-form-number-box-readonly :meta='meta.metaT1sr' :server-data='userData' :is-modified="isModified" />
        <ai-form-number-box-readonly :meta='meta.metaT2sr' :server-data='userData' :is-modified="isModified" />
    </div>
</template>
<script>
export default {
    name: 'tep-search-tmp-graf'
};
</script>
<script setup>
import { computed, inject, ref } from 'vue';
import { DxButton, DxPopup } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';

import AiFormTextBoxReadonly from '@/components/card-component/ai-form-text-box-readonly.vue';
import AiFormNumberBoxReadonly from '@/components/card-component/ai-form-number-box-readonly.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    }
});

const userData = inject('userData');
const popupVisible = ref(false);
const popupRef = ref(null);
const tgrNsiRef = ref(null);

const isModified = computed(() => {
    return userData?.value[props.meta.metaName.fieldNameText] !== props.serverData[props.meta.metaName.fieldNameText];
});

const openNsi = () => {
    popupVisible.value = true;
    tgrNsiRef.value?.onStart();
}

const onNsiClose = (e) => {
    if (popupVisible.value) {
        e.cancel = true;
        tgrNsiRef.value?.beforeNsiClose(); // эта функция вызовет через emit функцию onChooseTgr и закроет при необходимости popup
    }
}

const onChooseTgr = (tgrItem, isTgrChosen) => {
    if (!isTgrChosen) { // если не была нажата кнопка выбора, то просто закрываем popup
        popupVisible.value = false;
        popupRef.value?.instance.hide();
        return;
    }
    if (tgrItem.kod_r === null) {
        dxUiNotify('СНИП не может быть выбран как температурный график для источника тепла', 'error', 5000);
        return;
    }

    userData.value.name_tg = tgrItem.name_pasp;
    userData.value.t1 = tgrItem.t1;
    userData.value.t2 = tgrItem.t2;
    userData.value.t1_sg = tgrItem.t1_sg;
    userData.value.t2_sg = tgrItem.t2_sg;
    userData.value.kod_tgr = tgrItem.kod;

    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    popupVisible.value = false;
    popupRef.value?.instance.hide();
}
</script>
<style scoped>
.inline-card-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.inline-card-cont :deep(.dx-field) {
    margin: 0 10px;
}
.tep-tmp-open-btn {
    display: flex;
    align-items: end;
    height: 66px;
    padding: 10px 0;
}
</style>
